import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/keywords")({
  component: KeywordsRedirect,
  head: () => ({
    meta: [
      { title: "Redirecting..." },
      { name: "robots", content: "noindex, nofollow" },
      {
        name: "description",
        content: "Redirecting to Keywords People Use.",
      },
    ],
  }),
});

function KeywordsRedirect() {
  if (typeof window !== "undefined") {
    window.location.replace("https://keywordspeopleuse.com/");
  }
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4 text-center">
      <p className="text-muted-foreground">
        Redirecting to{" "}
        <a
          href="https://keywordspeopleuse.com/"
          className="text-primary underline"
        >
          Keywords People Use
        </a>
        ...
      </p>
    </div>
  );
}
